<template>
	<li>
		<img
			v-if="user.photoURL"
			:title="`${user.firstName} ${user.lastName} | @${user.username}`"
			v-lazy="user.photoURL"
			alt="Profile picture"
			:class="user.deleted ? 'user-deleted' : ''"
		/>
		<no-user-image
			v-else
			:firstName="user.firstName"
			:lastName="user.lastName"
			:fontSize="14"
			:height="'40px'"
			:width="'40px'"
		></no-user-image>
	</li>
</template>

<script>
import NoUserImage from "../../errors/NoUserImage.vue";

export default {
	props: {
		user: {
			type: Object
		}
	},
	components: {
		NoUserImage
	}
};
</script>

<style scoped>
li {
	height: 40px;
	width: 40px;
}

img {
	height: 40px;
	width: 40px;
	border-radius: 50%;
	object-fit: cover;
	/* margin-right: 5px; */
	border: 2px solid #171717;
}

.user-deleted {
	opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/components/users/userLists/UserImagesListItem.vue